export enum FileExtensionEnum {
  con = 'con',
  doc = 'doc',
  docx = 'docx',
  gif = 'gif',
  html = 'html',
  jpeg = 'jpeg',
  jpg = 'jpg',
  json = 'json',
  ldt = 'ldt', // Labordatentraeger
  mp4 = 'mp4',
  pad = 'pad', // Praxisarchivdatei
  pdf = 'pdf',
  png = 'png',
  tif = 'tif',
  tiff = 'tiff',
  txt = 'txt',
  xkm = 'xkm', // Verschlüsselte Dateien, siehe https://update.kbv.de/ita-update/KBV-Software/Kryptomodul/KBV_ITA_AHEX_Handbuch_Kryptomodul.pdf
  xml = 'xml',
  zip = 'zip',
  rtf = 'rtf',
  odt = 'odt',
}
